module.exports = __webpack_public_path__ + "img/nav_icon_midwife.f3dd37fc.svg";